import { ActivityTagItem } from '@spotify/plugin-confidence-activity-react';
import { createMetricUpdatesChangeExtension } from '@spotify/plugin-confidence-metrics-react';

import {
  formatDuration,
  parseDuration,
} from '../../../components/ScheduleIntervalsSection/utils/durationUtils';

const formatDurationValue = (value: unknown): string => {
  if (typeof value !== 'string') return '';
  const seconds = parseDuration(value);
  return formatDuration(seconds);
};

export const METRIC_DURATION_CHANGE_EXTENSION =
  createMetricUpdatesChangeExtension({
    id: 'metric-duration-change',
    predicate: ({ change }) => change.fieldType === 'google.protobuf.Duration',
    render: ({ change }) => (
      <ActivityTagItem
        oldValue={formatDurationValue(change.oldValue)}
        newValue={formatDurationValue(change.newValue)}
      />
    ),
  });
